import { post } from './http';
import { isRecord, toFoodSummary, type FoodSummary } from './types';

const SEARCH_TIMEOUT_MS = 8000;
const MAX_PAGE_SIZE = 100;

// Runs in the browser. The glucose search API is CORS-locked to production,
// so this does not follow API_BASE_URL the way details and tips do.
const SEARCH_URL = 'https://api.ultrahuman.com/api/v4/glucose_database/search';

/** Never rejects: no match (the API sends a string), a 204 and any failure all yield []. */
export async function searchFood({
  query,
  count = 10,
  page = 1,
  timeoutMs = SEARCH_TIMEOUT_MS,
}: {
  query: string;
  count?: number;
  page?: number;
  timeoutMs?: number;
}): Promise<FoodSummary[]> {
  const searchString = query.trim();
  if (!searchString) return [];

  try {
    const { status, body } = await post(SEARCH_URL, timeoutMs, {
      headers: { TimeZone: 'Asia/Kolkata', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        search_string: searchString,
        per_page: Math.min(Math.max(1, count), MAX_PAGE_SIZE),
        page: Math.max(1, page),
      }),
    });
    if (status === 204) return [];
    if (status !== 200) {
      console.error(`[ogdb] search failed (HTTP ${status})`);
      return [];
    }
    const data = isRecord(body) ? body.data : null;
    return Array.isArray(data)
      ? data.map(toFoodSummary).filter((f): f is FoodSummary => f !== null)
      : [];
  } catch (e) {
    console.error('[ogdb] search failed', String(e));
    return [];
  }
}
